import BannersSectionView from './BannersSectionView';

export default BannersSectionView;
